import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28f97181"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "draggable"]
const _hoisted_2 = { class: "card-handle" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mn-tag tag-person waiting"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "card-footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon" }, null, -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card-content" }
const _hoisted_13 = { class: "menuheader" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = { class: "card-content" }

import { Resolution } from '@/logic/workspaces/tickets/_def';

import { onTicketItemDrage, onTicketItemDragEnd } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'
import { downloadTicketFile } from '@/controllers/workspaces/tickets/_spec/ticket.controller'

import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { taskStatusCss } from '@/controllers/workspaces/tickets/task.controller'
import { clipboardTicketTitle } from '@/controllers/workspaces/tickets/_spec/ticket.controller'

import uiController, { emitDefinition, IEmits } from '@/components/Workspaces/tickets/_spec/ticket.controller.ui'
import { useAppContext } from '@/app/_tech';
import { ITicketUiElementController } from './ticket.controller.elementary.interface';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { LabelModel } from '@/app.context/workspace/label.rmodel';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { BlockRmodel } from '@/app.context/workspace/tickets/tasks/block.rmodel';
import { computed, ref } from 'vue';
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';
import { minuteCalc } from '@/logic/_infra/time'
import { Timespending } from '@/app.context/workspace/Event';

import TicketTimingComponent from '@/components/Workspaces/todos/_spec/TicketTiming.vue'




export default /*#__PURE__*/_defineComponent({
  __name: 'TicketCard',
  props: {
    ticket: {},
    todo: {},
    level: {},
    circledX: { type: Boolean },
    controller: {},
    efforts: {}
  },
  emits: emitDefinition,
  setup(__props: any, { emit: __emit }) {


const context = useAppContext();

const props = __props

const emit = __emit





const triggers: IEmits =
{
    v: () => emit("v"),
    x: () => emit("x"),
    o: () => emit("o"),
    block: function (b: BlockRmodel): void {
        emit("block", b)
    },
    files: function (f: boolean | File[]): void {
        emit("files", f)
    },
    click: function (): void {
        emit("click")
    },
    label: function (l: LabelModel): void {
        emit("label", l)
    },
    person: function (person: PersonRmodel, position: number | null): void {
        emit("person", person, position)
    },
    stop: function (): void {

        emit('stop')
    },
    command: function (value: string, ticket: TicketRmodel): void {
        emit("command", value, ticket)
    }
}


const input = ref<HTMLInputElement | null>(null)


const { mode, blockers, block_impersonal_ui, ticket, h, ui, personTags, cardClass } = uiController(props, triggers, input)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _unref(cardClass)]),
    id: _unref(ticket).n.toString(),
    draggable: _unref(mode).level >= _unref(TicketAccessLevel).Full,
    onDragstart: _cache[26] || (_cache[26] = ($event: any) => (_unref(onTicketItemDrage)($event, props))),
    onDragend: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_unref(onTicketItemDragEnd) && _unref(onTicketItemDragEnd)(...args))),
    onDrop: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).drop && _unref(h).drop(...args)), ["prevent"])),
    onDragenter: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clipboardTicketTitle)(_unref(ticket)))),
        class: "card-n"
      }, [
        _createTextVNode(_toDisplayString(_unref(ticket).n), 1),
        (props.todo?.isDerivative() ?? false)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "'"))
          : _createCommentVNode("", true)
      ]),
      (props.todo?.isDerivative() ?? false)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.todo?.derivativePerson()!.name), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personTags), (t) => {
        return (_openBlock(), _createElementBlock("span", {
          onClick: _withModifiers(($event: any) => (_unref(h).person_label(t)), ["stop"]),
          class: _normalizeClass(["mn-tag tag-person clickable", _unref(taskStatusCss)(t)]),
          key: t.person.name
        }, _toDisplayString(t.person.name), 11, _hoisted_5))
      }), 128)),
      _withDirectives(_createElementVNode("span", null, [
        (_unref(mode).level >= _unref(TicketAccessLevel).Normal && _unref(ticket).resolution != _unref(Resolution).Failed)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(h).stop && _unref(h).stop(...args))),
              class: "bi bi-stop right"
            }))
          : _createCommentVNode("", true),
        (_unref(mode).level >= _unref(TicketAccessLevel).Normal && _unref(ticket).resolution == _unref(Resolution).Failed)
          ? (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "bi-arrow-counterclockwise right",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(h).reset && _unref(h).reset(...args)))
            }))
          : _createCommentVNode("", true),
        (_unref(mode).level >= _unref(TicketAccessLevel).Full)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (props.circledX === true)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(ticket).isArchieved())
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "bi-x-lg right",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(h).cross && _unref(h).cross(...args)))
                        }))
                      : (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: "bi-x-circle right",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(h).cross && _unref(h).cross(...args)))
                        }))
                  ], 64))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "bi-x-lg right",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(h).cross && _unref(h).cross(...args)))
                  }))
            ], 64))
          : _createCommentVNode("", true),
        (_unref(mode).level >= _unref(TicketAccessLevel).Normal && _unref(ticket).resolution != _unref(Resolution).Done)
          ? (_openBlock(), _createElementBlock("i", {
              key: 3,
              class: "bi-check-lg right",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(h).check && _unref(h).check(...args)))
            }))
          : _createCommentVNode("", true),
        (_unref(mode).level >= _unref(TicketAccessLevel).Normal && _unref(ticket).resolution == _unref(Resolution).Done)
          ? (_openBlock(), _createElementBlock("i", {
              key: 4,
              class: "bi-check-lg card-icon-green bold right",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(h).reset && _unref(h).reset(...args)))
            }))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, _unref(mode).menu == 0]
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).click && _unref(h).click(...args)), ["prevent"])),
      onContextmenu: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).click_right && _unref(h).click_right(...args)), ["right","prevent"])),
      class: "card-body"
    }, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("span", null, [
          _createElementVNode("input", {
            ref_key: "input",
            ref: input,
            type: "text",
            value: _unref(ticket).name,
            onKeyup: [
              _cache[8] || (_cache[8] = _withKeys(($event: any) => (_unref(mode).editing = false), ["esc"])),
              _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_unref(h).name_submit && _unref(h).name_submit(...args)), ["enter"]))
            ],
            onClick: _cache[10] || (_cache[10] = (x) => x.stopPropagation())
          }, null, 40, _hoisted_7)
        ], 512), [
          [_vShow, _unref(mode).editing]
        ]),
        (!_unref(mode).editing)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).edit && _unref(ui).edit(...args)), ["stop"])),
                class: "card-content-text"
              }, _toDisplayString(_unref(ticket).name), 1),
              (_unref(ticket).name.length == 0)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "bi-pen",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).edit && _unref(ui).edit(...args)), ["stop"]))
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(ticket).file != null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "card-content-attachment bi-paperclip",
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_unref(downloadTicketFile)(_unref(ticket), _unref(context))), ["stop"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_unref(block_impersonal_ui) != null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_unref(h).block(_unref(block_impersonal_ui))), ["stop"])),
              class: "mn-tag tag-person waiting clickable"
            }, [
              _createTextVNode("  "),
              _hoisted_9,
              _createTextVNode("  ")
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blockers), (b) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "mn-tag tag-person waiting clickable",
            onClick: _withModifiers(($event: any) => (_unref(h).block(b)), ["stop"]),
            key: b.person!.nid.toString()
          }, _toDisplayString(b.person!.name), 9, _hoisted_10))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticket).labels, (l) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: _withModifiers(($event: any) => (_unref(h).tag_label(l)), ["stop"]),
            class: "mn-tag tag-label",
            key: l.name
          }, _toDisplayString(l.name), 9, _hoisted_11))
        }), 128))
      ])
    ], 544), [
      [_vShow, _unref(mode).menu == 0]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "card-body",
      onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["stop"])),
      onContextmenu: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["right","prevent"]))
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", null, _toDisplayString(_unref(ticket).name), 1)
        ]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticket).workspace.persons(), (p, i) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "clickable card-submenu-item",
              onClick: _withModifiers(($event: any) => (_unref(ui).personMenuSet(p)), ["stop"]),
              key: p.name
            }, [
              (i != 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("•")
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(p.name), 1)
            ], 8, _hoisted_14))
          }), 128))
        ]),
        _hoisted_15,
        (_unref(mode).menu == 1)
          ? (_openBlock(), _createBlock(TicketTimingComponent, {
              key: 0,
              ticket: _unref(ticket),
              todo: _ctx.todo,
              efforts: _ctx.efforts
            }, null, 8, ["ticket", "todo", "efforts"]))
          : _createCommentVNode("", true)
      ])
    ], 544), [
      [_vShow, _unref(mode).menu == 1]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "card-body",
      onClick: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["stop"])),
      onContextmenu: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["right","prevent"]))
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, 0)), ["stop"]))
        }, "Now"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, 1)), ["stop"]))
        }, "Next"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, 2)), ["stop"]))
        }, "Soon"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, -1)), ["stop"]))
        }, "Last"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, -2)), ["stop"]))
        }, "Someday")
      ])
    ], 544), [
      [_vShow, _unref(mode).menu == 2]
    ])
  ], 42, _hoisted_1))
}
}

})